module.exports = __webpack_public_path__ + "img/1.488bbfed.jpg";